/** Calculate BMI from height (inches) and weight (lbs). */
export function calculateBMI(heightInches: number, weightLbs: number): number {
    if (heightInches <= 0 || weightLbs <= 0) return 0;
    return (weightLbs / (heightInches * heightInches)) * 703;
}

export type BMICategory = 'Underweight' | 'Normal' | 'Overweight' | 'Obese';

export function getBMICategory(bmi: number): BMICategory {
    if (bmi < 18.5) return 'Underweight';
    if (bmi < 25) return 'Normal';
    if (bmi < 30) return 'Overweight';
    return 'Obese';
}

export function getBMICategoryColor(category: BMICategory): string {
    switch (category) {
        case 'Normal':
            return 'text-green-600 bg-green-50';
        case 'Underweight':
            return 'text-yellow-600 bg-yellow-50';
        case 'Overweight':
            return 'text-orange-600 bg-orange-50';
        case 'Obese':
            return 'text-red-600 bg-red-50';
    }
}
